/**
 * 成交公告列表页路径
 */
export const TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH =
  '/announcement/transaction/list'

/**
 * 成交公告详情页路径
 */
export const TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH =
  '/announcement/transaction/detail'
